module.exports = __webpack_public_path__ + "media/andenes/abrigo_anden-f4f73115.webp";